import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PayInvoiceStyles from "./PayInvoice.styles";
import { Close } from "@material-ui/icons";
import CenteredContent from "../../../components/sharedComponents/CenteredContent";
import { useSelector } from "react-redux";
import { selectUserId/* , selectUserName */ } from "../../../store/slices/user";
import AnimationContent from "../../../components/sharedComponents/AnimationContent";
import LoadingAnimation from "../../../assets/lottieFiles/loaderAnimation.json";
import { PAY_INVOICE_TEXT_TICKET } from "../../../constants/constantMessages";
import useGetRouteName from "../../../hooks/useGetRouteName";
import useGetFolioNumber from "../../../hooks/useGetFolioNumber";
const PayInvoice = (props) => {
  const {
    handleClose,
    invoiceInfo,
    handleOpenAlert,
    handleSubmitPayment,
    loading,
    clientName,
  } = props;
  const classes = PayInvoiceStyles();
  const { id_invoice, remaining_payment } = invoiceInfo;
  const [payment, setPayment] = useState();
  const [comments, setComments] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [localization, setLocalization] = useState();
  const idUser = useSelector(selectUserId);
  const idPaymentFormat = useGetFolioNumber();
  const routeName = useGetRouteName();
  //const username = useSelector(selectUserName);

  const handlePayment = (payment) => {
    // Filtra el valor ingresado, permitiendo solo números enteros
    const numericValue = payment.replace(/\D/g, "");

    if (numericValue === "") {
      setPayment("");
      setError(false);
      return;
    }

    const intValue = parseInt(numericValue, 10);

    if (intValue > parseInt(remaining_payment)) {
      setError(true);
      setErrorMessage("La cantidad debe ser menor al adeudo");
    } else if (intValue <= 0) {
      setError(true);
      setErrorMessage("La cantidad debe ser mayor a cero");
    } else {
      setError(false);
    }

    setPayment(numericValue);
    handleOpenAlert();
  };

  useEffect(() => {
    if (navigator.geolocation) {
      //check if geolocation is available
      navigator.geolocation.getCurrentPosition(function (position) {
        let location = position.coords;
        let { latitude, longitude } = location;
        setLocalization(`${latitude}, ${longitude}`);
      });
    } else {
      setLocalization("20.000948124862976, -102.27041548703968");
    }
  }, []);

  const handlePaymentLink = () => {
    const tiket_payment_info = PAY_INVOICE_TEXT_TICKET(
      clientName,
      invoiceInfo.id_invoice,
      routeName,
      idPaymentFormat,
      invoiceInfo.remaining_payment,
      payment,
      parseInt(invoiceInfo.remaining_payment) - parseInt(payment),
      "" //username
    );
    let payload = {
      idPayment: String(idPaymentFormat),
      idInvoice: Number(id_invoice),
      amount: parseFloat(payment),
      locationGPS: localization ? localization : "",
      comments: comments,
      textTicket: tiket_payment_info,
      printedTicket: false,
    };
    handleSubmitPayment(payload);
  };

  return (
    <Box className={classes.mainContainer}>
      {!loading ? (
        <React.Fragment>
          <IconButton
            onClick={handleClose}
            className={classes.closeIconContainerMain}
          >
            <Close />
          </IconButton>

          <CenteredContent direction="column"></CenteredContent>
          <Box className={classes.containerBox}>
            <Typography variant="subtitle2" className={classes.title}>
              Realizar Abono
            </Typography>
            <Typography className={classes.message}>
              La cantidad designada, será restada <br />
              de la factura
            </Typography>
            <Typography variant="h3" className={classes.amountTitle}>
              Su adeudo actual
            </Typography>
            <Typography className={classes.amount}>
              ${remaining_payment}
            </Typography>

            <Typography className={classes.pay}>Cantidad a abonar</Typography>
            <TextField
              value={payment}
              onChange={(e) => handlePayment(e.target.value)}
              variant="outlined"
              placeholder="$100"
              error={error}
              helperText={error && errorMessage}
              inputProps={{
                inputMode: "numeric", // teclado numérico en móviles
                pattern: "[0-9]*",
                style: { textAlign: "initial" },
              }}
            />

            <Typography className={classes.restAmount}>
              Saldo restante
            </Typography>
            <Typography align="center" variant="h3" className={classes.amount}>
              $
              {payment &&
              payment > 0 &&
              parseInt(payment) <= parseInt(remaining_payment)
                ? `${parseInt(remaining_payment) - parseInt(payment)}.00`
                : `${parseInt(remaining_payment)}.00`}
            </Typography>

            <Typography
              align="center"
              variant="subtitle2"
              className={classes.comments}
            >
              Comentarios(Opcional)
            </Typography>
            <TextField
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              variant="outlined"
              className={classes.commentsField}
              inputProps={{ className: classes.commentsMultiline }}
              multiline
            />
          </Box>
          <CenteredContent>
            <Button
              variant="contained"
              color="primary"
              className={classes.paymentButton}
              disabled={!payment || error ? true : false}
              onClick={handlePaymentLink}
            >
              Abonar
            </Button>
          </CenteredContent>
        </React.Fragment>
      ) : (
        <CenteredContent style={{ height: "100%" }} direction="column">
          <AnimationContent animationFile={LoadingAnimation} />
          <Typography align="center" variant="h6">
            Realizando el abono
          </Typography>
          <Typography align="center" variant="body2">
            No cierre la pantalla{" "}
          </Typography>
        </CenteredContent>
      )}
    </Box>
  );
};

export default PayInvoice;
